// react
import React from "react";

// third-party
import classNames from "classnames";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

// application
import AsyncAction from "../shared/AsyncAction";
import { ArrowRoundedRight6x9Svg, Cart16Svg, LocationPin } from "../../svg";
import { cartAddItem } from "../../store/cart";
import { url } from "../../services/utils";
import BlockLoader from "../blocks/BlockLoader";

const Suggestions = React.memo((props) => {
    const { context, className, products, toko, cartAddItem, isLoading, customer, query } = props;
    const rootClasses = classNames(`suggestions suggestions--location--${context}`, className);

    const handleAddCart = (product) => {
        if (customer.token !== undefined && customer.token !== "") {
            return cartAddItem(product, customer.token);
        } else {
            return new Promise((resolve) => {
                // window.open("https://sso.datadik.kemdikbud.go.id/app/3D1C4271-7C02-487E-B330-7294B7EB4564", "_self");
                props.history.push("/login");
                resolve();
            });
        }
    };

    // PPN rate - standard Indonesian VAT rate is 11%
    const ppnRate = 0.11;

    const list =
        products &&
        products.map((product) => {
            // Calculate PPN amount
            const price =
                typeof product.price.primary === "number"
                    ? product.price.primary
                    : parseFloat(product.price.primary || 0);

            // Check if product is tax exempt (you may need to adjust this condition based on your actual data structure)
            const isTaxExempt = product.taxExempt || product.isTaxExempt || false;

            // Calculate PPN amount (0 if tax exempt)
            const ppnAmount = isTaxExempt ? 0 : price * ppnRate;

            // Format price to show rounded amount without decimals if needed
            const formattedPrice = isTaxExempt
                ? `Rp ${Math.round(price).toLocaleString("id-ID")}`
                : product.price.primaryCurrencyFormat;

            return (
                <li key={product.id} className="suggestions__item">
                    {product.images && product.images.length > 0 && (
                        <div className="suggestions__item-image product-image">
                            <div className="product-image__body">
                                <img className="product-image__img" src={product.images[0]} alt="" />
                            </div>
                        </div>
                    )}
                    <div className="suggestions__item-info">
                        <Link className="suggestions__item-name" to={url.product(product)}>
                            {product.name}
                        </Link>
                        <div className="suggestions__item-meta">{product.mall?.name}</div>
                    </div>
                    <div className="suggestions__item-price">
                        {formattedPrice}
                        <div className="suggestions__item-ppn" style={{ fontSize: "11px", color: "#6c757d" }}>
                            {isTaxExempt ? (
                                <>
                                    Bebas Pajak
                                    <div>DPP Nilai Lain: {formattedPrice}</div>
                                    <div>PPN = Rp 0</div>
                                </>
                            ) : (
                                <>Termasuk PPN {(ppnRate * 100).toFixed(0)}%</>
                            )}
                        </div>
                    </div>
                    {context === "header" && (
                        <div className="suggestions__item-actions">
                            <AsyncAction
                                action={() => handleAddCart(product)}
                                render={({ run, loading }) => (
                                    <button
                                        type="button"
                                        onClick={run}
                                        title="Add to cart"
                                        className={classNames("btn btn-primary btn-sm btn-svg-icon", {
                                            "btn-loading": loading,
                                        })}
                                    >
                                        <Cart16Svg />
                                    </button>
                                )}
                            />
                        </div>
                    )}
                </li>
            );
        });

    const listToko =
        toko &&
        toko.map((mall) => (
            <li key={mall.id} className="suggestions__item">
                {mall.image && (
                    <div className="suggestions__item-image product-image">
                        <div className="product-image__body">
                            <img className="product-image__img" src={mall.image.primary} alt="" />
                        </div>
                    </div>
                )}
                <div className="suggestions__item-info">
                    <Link className="suggestions__item-name">{mall.name}</Link>
                    <div className="suggestions__item-meta">{mall.location.city}</div>
                </div>
            </li>
        ));

    return (
        <div className={rootClasses}>
            {isLoading ? (
                <BlockLoader />
            ) : (
                <ul className="suggestions__list">
                    <li className="suggestions__item">
                        <div>BARANG</div>
                    </li>
                    {list.length > 0 ? (
                        <>
                            {list}
                            <li className="suggestions__item d-flex justify-content-center">
                                <Link
                                    to={`/products/search?keyword=${query}`}
                                    className="suggestions__item-name"
                                    style={{ color: "#0E336D" }}
                                >
                                    Lihat Produk Lainnya
                                </Link>
                            </li>
                        </>
                    ) : (
                        <li className="d-flex justify-content-center py-3">Produk tidak ditemukan</li>
                    )}

                    <li className="suggestions__item">
                        <div>TOKO</div>
                    </li>
                    {listToko.length > 0 ? (
                        <>
                            {listToko}
                            <li className="suggestions__item">
                                <Link
                                    to={`/store?keyword=${query}`}
                                    className="suggestions__item-name d-flex justify-content-between align-items-center w-100"
                                >
                                    <div style={{ color: "#0E336D" }}>Lihat Pencarian Toko "{query}" Lainnya</div>
                                    <ArrowRoundedRight6x9Svg />
                                </Link>
                            </li>
                        </>
                    ) : (
                        <li className="d-flex justify-content-center py-3">Toko tidak ditemukan</li>
                    )}
                </ul>
            )}
        </div>
    );
});

const mapStateToProps = (state) => ({ customer: state.customer });

const mapDispatchToProps = {
    cartAddItem,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Suggestions));
